/** Futures trade on HNXDS. Their position cost is posted margin, held qty is contracts, price is index points. */
export const isFuturesExchange = (exchange: string | null | undefined): boolean =>
  (exchange ?? '').toUpperCase() === 'HNXDS';
